import React, { useState } from 'react';

export const BaseDataContext = React.createContext();

export const BaseDataProvider = (props) => {
  const [baseData, setBaseData] = useState(
    {
      issues: [],
      cruiselines: [],
      ships: [],
      cabinprimarytypes: [],
      regions: [],
      stoppoints: [],
      sortbyList: [],
      pictureserver: ""
    });

  return (
    <BaseDataContext.Provider value={[baseData, setBaseData]}>
      {props.children}
    </BaseDataContext.Provider>
  );
};